import { EFilterType } from '@domain/enums/components/EFilter';
import { IFilterConfig } from '@domain/interfaces/components/IFilter';

export const FINANCIAL_FILTER_CONFIG: Array<IFilterConfig> = [
  {
    field: 'order_field',
    label: 'Data',
    type: EFilterType.SELECT,
    config: {
      placeholder: 'Buscar por data...',
      data: [
        {
          value: 'provider_created_at',
          label: 'Criação do pedido',
        },
        {
          value: 'approved_at',
          label: 'Aprovação do pedido',
        },
      ],
    },
  },
];
